// routesConstants.js

// Main route paths
export const ROUTES = {
  // Private / Main pages
  HOME: '/',
  DASHBOARD: '/dashboard',
  ALERTS: '/alerts',
  HAZMAT: '/hazmat',
  DEVICES: '/device',
  DEVICE_LOCATION: '/device/device_location',
  REPORTS: '/reports',
  ACCOUNT: '/account',
  SUPPORT: '/customer-support',
  SUPPORT_ACCOUNT_DETAILS: '/customer-support/accounts/:id',
  MODULES: '/modules',
  DEVICE_LOGS: '/devicelog',
  E_SCREEN_TRAILER: '/e-screen-trailer',

  // Public pages
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  PAGE_404: '/404',
  PAGE_500: '/500',
}

// Route display names
export const ROUTE_NAMES = {
  // Private / Main pages
  HOME: 'Home',
  DASHBOARD: 'Dashboard',
  ALERTS: 'Alerts',
  HAZMAT: 'HazMat',
  DEVICES: 'Devices',
  DEVICE_LOCATION: 'Device Location',
  REPORTS: 'Reports',
  ACCOUNT: 'Account',
  SUPPORT: 'Customer Support',
  SUPPORT_ACCOUNT_DETAILS: 'Customer Support Details',
  MODULES: 'Modules',
  DEVICE_LOGS: 'Device Readings',
  E_SCREEN_TRAILER: 'E-Screen Trailer',

  // Public pages
  LOGIN: 'Login',
  FORGOT_PASSWORD: 'Forgot Password',
  RESET_PASSWORD: 'Reset Password',
  PAGE_404: 'Page Not Found',
  PAGE_500: 'Error Page',

  // Device Logs subpages
  EVENT_STATS: 'Event Stats',
  INFO: 'Info',
  READ_STATS: 'Read Stats',
  AUDITLOG: 'Auditlog',
  CONFIG: 'Config',
  LAST_REBOOT: 'Last Reboot',
  OS: 'OS',
  STATUS: 'Status',
  STATUS_ID: 'Status ID',
  FIRMWARE: 'Firmware',
  HEARTBEAT: 'Heartbeat',

  // Account subpages
  USERS: 'Users',
  DEVICE_RELAYS: 'Device Relays',
  SECURITY: 'Security',
  ACCOUNT_TAB: 'Account Tab',
  SITE_LANE: 'Site Lane',
  ACCOUNT_ALERTS: 'Alerts',
  ACCOUNT_AUDITLOG: 'Auditlog',
  UPDATES: 'Updates',
  TOKENS: 'Tokens',

  // Support subpages
  SUPPORT_ACCOUNTS: 'Accounts',
  SUPPORT_USERS: 'Users',
  SUPPORT_SETTINGS: 'Settings',
  SUPPORT_LICENSES: 'Licenses',
  SUPPORT_MODULES: 'Modules',
}

// Device Logs subpage paths
export const DEVICE_LOGS_SUB = {
  EVENT_STATS: 'event_stats',
  INFO: 'info',
  READ_STATS: 'read_stats',
  AUDITLOG: 'auditlog',
  CONFIG: 'config',
  LAST_REBOOT: 'last_reboot',
  OS: 'os',
  STATUS: 'status',
  STATUS_ID: 'status_id',
  FIRMWARE: 'firmware',
  HEARTBEAT: 'heartbeat',
}

// Account subpage paths
export const ACCOUNT_SUB = {
  USERS: 'users',
  DEVICE_RELAYS: 'device_relays',
  SECURITY: 'security',
  ACCOUNT_TAB: 'account',
  SITE_LANE: 'site_lane',
  ALERTS: 'alerts',
  AUDITLOG: 'auditlog',
  UPDATES: 'updates',
  TOKENS: 'tokens',
}

// Support subpage paths
export const SUPPORT_SUB = {
  ACCOUNTS: 'accounts',
  USERS: 'users',
  SETTINGS: 'settings',
  LICENSES: 'licenses',
  MODULES: 'modules',
}
